import { createContext } from "react";

const SampleSubmissionContext = createContext();

export default SampleSubmissionContext;
